import { FC, useMemo } from 'react';

import styles from 'src/styles/common/templateGallery.module.scss';
import { useNsTHelper } from 'src/utils/i18n';
import { TemplateGallerySweepstakesIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Sweepstakes';
import { TemplateGalleryTicketingIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Ticketing';
import { TemplateGalleryAThonIcon } from 'src/components/Modals/TemplateGallery/icons/activities/AThon';
import { TemplateGalleryAuctionIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Auction';
import { TemplateGalleryCrowdfundingIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Crowdfunding';
import { TemplateGalleryRaffleIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Raffle';
import { TemplateGallerySalesIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Sales';
import { TemplateGalleryLivestreamingIcon } from 'src/components/Modals/TemplateGallery/icons/activities/Livestreaming';
import { TemplateGalleryPeerToPeerIcon } from 'src/components/Modals/TemplateGallery/icons/activities/PeerToPeer';

type Props = {
  items: number[];
};

export const TemplateGalleryActivities: FC<Props> = ({ items }) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'details');

  const activities = useMemo(
    () =>
      [
        { value: 1, label: 'crowdfunding', icon: TemplateGalleryCrowdfundingIcon },
        { value: 2, label: 'ticketing', icon: TemplateGalleryTicketingIcon },
        { value: 3, label: 'sales', icon: TemplateGallerySalesIcon },
        { value: 4, label: 'auction', icon: TemplateGalleryAuctionIcon },
        { value: 5, label: 'aThon', icon: TemplateGalleryAThonIcon },
        { value: 6, label: 'raffle', icon: TemplateGalleryRaffleIcon },
        { value: 7, label: 'sweepstakes', icon: TemplateGallerySweepstakesIcon },
        { value: 8, label: 'peerToPeer', icon: TemplateGalleryPeerToPeerIcon },
        { value: 9, label: 'livestreaming', icon: TemplateGalleryLivestreamingIcon },
      ].filter((item) => items.includes(item.value)),
    [items]
  );

  return (
    <div className={styles.activities}>
      <div className={styles.subhead}>{tHelper('activities.subhead')}</div>
      <div className={styles.list}>
        {activities.map(({ value, label, icon: Icon }) => (
          <div key={value} className={styles.activity}>
            <Icon className={styles.icon} />
            <span>{tHelper(`activities.${label}`)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
